module.exports = __webpack_public_path__ + "img/ptzc-large-two.2b53ae93.png";